import './index.sass';
import React from 'react';
import ReactDOM from 'react-dom';

const App = () => (
  <div style={{
    minHeight: '100vh',
    backgroundColor: '#1a1a1a',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  }}>
    <div style={{ textAlign: 'center', maxWidth: 400 }}>
      <div style={{ fontSize: 72, color: '#666', marginBottom: 24 }}>:(</div>
      <h1 style={{ fontSize: 24, fontWeight: 600, color: '#fff', marginBottom: 16 }}>
        Service Closed
      </h1>
      <p style={{ fontSize: 16, color: '#888', lineHeight: 1.6, marginBottom: 16 }}>
        Anime Fans was created as a community for anime lovers. Unfortunately, over the past few days we experienced a sudden influx of users who began posting prohibited content.
      </p>
      <p style={{ fontSize: 16, color: '#888', lineHeight: 1.6, marginBottom: 16 }}>
        As soon as we became aware of this, we immediately shut down the service and deleted all content from our servers.
      </p>
      <p style={{ fontSize: 16, color: '#888', lineHeight: 1.6 }}>
        We're truly sorry this happened.
      </p>
    </div>
  </div>
);

ReactDOM.render(<App />, document.getElementById('root'));
